module.exports = __webpack_public_path__ + "img/nyitott palyazatok_gomb.448092c0.png";